import * as yup from 'yup';

import { DESCRIPTION_FIELD_MAX_LENGTH } from 'app/global/variables';

import { formatMessage } from 'utils/messages/utils';

interface DateRequirements {
  isStartDateRequired: boolean;
  isEndDateRequired: boolean;
}

interface BuildValidationSchemaOptions {
  isEffectiveDatesEnabled: boolean;
  dateRequirements?: DateRequirements | null;
}

const buildValidationSchema = ({ isEffectiveDatesEnabled, dateRequirements }: BuildValidationSchemaOptions) => {
  const schemaShape: Record<string, yup.AnySchema> = {
    name: yup.string().max(256).required(formatMessage('ENTER_TERRITORY_GROUP_NAME')).label(formatMessage('ADD')),

    description: yup
      .string()
      .max(
        DESCRIPTION_FIELD_MAX_LENGTH,
        formatMessage('DESCRIPTION_CHARACTER_LIMIT', { max: DESCRIPTION_FIELD_MAX_LENGTH })
      ),

    territoryGroupOwner: yup.object({
      key: yup.string().nullable(),
      value: yup.number().nullable()
    }),

    effectiveDate: yup.string().nullable(),
    endDate: yup.string().nullable()
  };

  if (isEffectiveDatesEnabled && dateRequirements) {
    const { isStartDateRequired, isEndDateRequired } = dateRequirements;

    if (isStartDateRequired) {
      schemaShape.effectiveDate = yup.string().required(formatMessage('REQUIRED_EFFECTIVE_START_DATE')).nullable();
    }

    if (isEndDateRequired) {
      schemaShape.endDate = yup.string().required(formatMessage('REQUIRED_EFFECTIVE_END_DATE')).nullable();
    }
  }

  return yup.object().shape(schemaShape);
};

export default buildValidationSchema;
